export default "__VITE_ASSET__6YZqR6VI__"